import { render, staticRenderFns } from "./IsShowPhone.vue?vue&type=template&id=21e072b5&scoped=true"
import script from "./IsShowPhone.vue?vue&type=script&lang=js"
export * from "./IsShowPhone.vue?vue&type=script&lang=js"
import style0 from "./IsShowPhone.vue?vue&type=style&index=0&id=21e072b5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e072b5",
  null
  
)

export default component.exports